// Showcase project for Portfolio
// Slides ->
//  Slide 1
//  Slide 2
// Slides have image on left and details on right, in mobile image is on top and details on bottom
// return to home button
// go to next and previous project buttons

import React from 'react';
import { useLocation } from 'react-router-dom';
import Container from '../Components/Container/Container';
import ProjectSlide from '../Components/ProjectSlide/ProjectSlide';

 const ProjectPage = () => {
    const location = useLocation();
    console.log(location);
    const project = location.state?.project;

    const [currentSlideIndex, setCurrentSlideIndex] = React.useState<number>(0);
    const currentSlide = project.slides[currentSlideIndex];

    const baseUrl = process.env.PUBLIC_URL || window.location.origin + '/';

    React.useEffect(() => {
        if (!project?.slides?.length) return;

        const preload = (imagePath: string | undefined) => {
            if (!imagePath) return;
            const img = new Image();
            img.src = baseUrl + imagePath;
        };

        const lastIndex = project.slides.length - 1;
        const prevIndex = currentSlideIndex === 0 ? lastIndex : currentSlideIndex - 1;
        const nextIndex = currentSlideIndex === lastIndex ? 0 : currentSlideIndex + 1;

        preload(project.slides[prevIndex]?.image);
        preload(project.slides[nextIndex]?.image);
    }, [baseUrl, currentSlideIndex, project]);

    const lastSlide = project.slides.length;

    const getPreviousSlide = () => {
        const prevIndex = currentSlideIndex === 0 ? lastSlide - 1 : currentSlideIndex - 1;
        return project.slides[prevIndex];
    };

    const getNextSlide = () => {
        const nextIndex = currentSlideIndex === lastSlide - 1 ? 0 : currentSlideIndex + 1;
        return project.slides[nextIndex];
    };

    const handleNextSlide = () => {
        const nextIndex = currentSlideIndex === lastSlide - 1 ? 0 : currentSlideIndex + 1;
        setCurrentSlideIndex(nextIndex);
    };

    const handlePreviousSlide = () => { 
        const prevIndex = currentSlideIndex === 0 ? lastSlide - 1 : currentSlideIndex - 1;
        setCurrentSlideIndex(prevIndex);
    };

    return (
        <div>
            {currentSlide && (
                <ProjectSlide
                    id={currentSlide.id}
                    image={currentSlide.image}
                    alt={currentSlide.alt}
                    title={currentSlide.title}
                    richText={currentSlide.richText}
                    project={project}
                    onPrevious={handlePreviousSlide}
                    onNext={handleNextSlide}
                    previousTitle={getPreviousSlide().title}
                    nextTitle={getNextSlide().title}
                />
            )}
        </div>
    )
}

export default ProjectPage